import { useAppTheme } from '@droplet-tech-code/core-elements/module/theme';
import { IconButton } from '@droplet-tech-code/core-elements/module/ui/Button';
import { useSearchState } from '@droplet-tech-code/core-elements/module/ui/Search/Search';
import { HStack, VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { Text } from '@droplet-tech-code/core-elements/module/ui/Text';
import { View } from '@droplet-tech-code/core-elements/module/ui/View';
import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { FerryCompanyDiscount } from '@naus-code/naus-server-common-types';
import { useCallback } from 'react';
import { RefreshControl } from 'react-native-gesture-handler';

import { useAddFerryCompanyDiscountModal } from '~/components/Config/CompanyConfig/Modals/Tickets/Modals';
import { ConfigListSectionTitle } from '~/components/Config/ConfigLitst.SectionTitle';
import { FlatList } from '~/components/FlatList/FlatList';
import { ScreenPropDiscountsConfig } from '~/navigation/Navigation.types';
import { translate } from '~/utils/translation.utils';

import { CompanyConfigItemHeader } from '../../CompanyConfig.ItemHeader';
import { companyConfigApi } from '../../CompanyConfigs.api';
import { DiscountConfig } from './DiscountConfig';

export const DiscountsConfig = ({ id }: { id: string }) => {
  const { spacing } = useAppTheme();
  const { data } = companyConfigApi.useGetFerryCompanyConfigQuery(id);
  const { open: openAddDiscountConfig } = useAddFerryCompanyDiscountModal(id);
  const {
    list: discounts,
    Search,
    isLoading,
    isFetching,
    refetch,
  } = useSearchState({
    hook: companyConfigApi.useGetFerryCompanyConfigQuery,
    style: {
      height: 47,
    },
    arg: id,
    keyToList: 'config.discountConfig',
  });

  const ItemSeparatorComponent = useCallback(() => <View my="1" />, []);

  if (discounts === undefined) {
    return null;
  }
  const allDiscounts = discounts.map((discount) => {
    return { ...discount, id: discount.code };
  });

  const renderItem = (discountConfig: FerryCompanyDiscount & { id: string }) => {
    return (
      <DiscountConfig
        companyId={id}
        check={data?.check || ''}
        discountConfig={discountConfig}
        key={discountConfig.id}
      />
    );
  };

  return (
    <VStack flex={1}>
      {isNativeMobile ? <CompanyConfigItemHeader id={id} /> : <></>}
      <VStack flex={1} p="2.5" space="2.5">
        <ConfigListSectionTitle>
          <HStack>
            <Text.Small flex={1} color="monochrome-mid">
              {translate('companyConfig.discounts')}
            </Text.Small>
            <IconButton icon="plus" onPress={openAddDiscountConfig} />
          </HStack>
        </ConfigListSectionTitle>
        {Search}
        <FlatList
          refreshControl={
            <RefreshControl refreshing={isFetching} onRefresh={() => refetch()} />
          }
          contentContainerStyle={[
            {
              paddingTop: spacing[2.5],
            },

            isNativeMobile && { paddingHorizontal: spacing[2] },
          ]}
          simple
          scrollEnabled
          feedback={translate('companyConfig.emptyDiscountsConfig')}
          isLoading={isLoading}
          data={allDiscounts}
          renderItem={renderItem}
          ItemSeparatorComponent={ItemSeparatorComponent}
        />
      </VStack>
    </VStack>
  );
};

export const DiscountsConfigScreen = (props: ScreenPropDiscountsConfig) => {
  return <DiscountsConfig id={props.route.params.id} />;
};
